import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileDown, FileUp, Loader2 } from "lucide-react";
import { api, errMsg, downloadFile } from "@/lib/api";

export const ImportStartList = ({ onDone }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/startlist/import", fd);
      toast.success(`Wgrano listę startową: ${data.imported} występów (${data.days.join(", ")})`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="grid gap-2" data-testid="import-startlist">
      <input ref={ref} type="file" accept=".xlsx" className="hidden" data-testid="import-startlist-input" onChange={(e) => pick(e.target.files[0])} />
      <div className="flex flex-wrap gap-2">
      <button type="button" data-testid="import-startlist-btn" disabled={busy} onClick={() => ref.current.click()}
        className="h-11 px-4 rounded-xl bg-blue-600 hover:bg-blue-500 text-sm font-semibold flex items-center gap-2 disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileUp className="w-4 h-4" />}Wgraj nową listę startową (Excel)
      </button>
      <button type="button" data-testid="startlist-template-btn" onClick={() => downloadFile({ path: "/admin/startlist/template.xlsx", filename: "wzor-listy-startowej.xlsx" }).catch((e) => toast.error(errMsg(e)))}
        className="h-11 px-4 rounded-xl border border-blue-500/40 text-blue-200 hover:bg-blue-500/10 text-sm flex items-center gap-2">
        <FileDown className="w-4 h-4" />Pobierz wzór pliku
      </button>
      </div>
      <p className="text-xs text-slate-400">Działa, gdy lista startowa jest pusta. Format jak dotychczasowy plik: każdy arkusz to jeden dzień (np. CZWARTEK), w wierszach: A – zawodnik / nazwa występu, B – kategoria, C – grupa wiekowa, D – klub, E – instruktor oraz godzina występu. Brakujące kategorie i grupy wiekowe dodadzą się same (ceny ustawisz w zakładce Kategorie).</p>
    </div>
  );
};
